import { render, staticRenderFns } from "./AccountHolder.vue?vue&type=template&id=52ca2af3&"
import script from "./AccountHolder.vue?vue&type=script&lang=js&"
export * from "./AccountHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports